import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  text: string
  iconType: IconType
  direction?: 'vertical' | 'horizon'
  color?: IconColor
  textColor?: TextColor
  textSize?: 10 | 12 | 14 | 16 | 20 | 24 | 32 | 40
  lineHeight?: 100 | 120 | 150
  iconLine?: boolean
  noBold?: boolean
  nowrap?: boolean
}

const IconText = ({
  text,
  iconType,
  direction = 'vertical',
  color = IconColor.PRIMARY,
  textColor = TextColor.PRIMARY,
  textSize,
  lineHeight = 120,
  iconLine = false,
  noBold = false,
  nowrap = false
}: Props) => {
  return (
    <div
      className={
        direction == 'vertical'
          ? 'flex h-30 flex-col items-center justify-start gap-y-2 py-5'
          : 'flex items-center gap-1'
      }
    >
      <Icon
        color={color}
        type={iconType}
        size={direction == 'vertical' ? 24 : 16}
        line={iconLine}
      />
      <Text
        color={textColor}
        size={textSize ?? 14}
        weight={noBold ? 'normal' : 'bold'}
        lineHeight={lineHeight}
        nowrap={nowrap}
      >
        {text}
      </Text>
    </div>
  )
}

export default IconText
